module.exports = __webpack_public_path__ + "static/media/AppleStore.5735c711.png";